import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import M from 'materialize-css';
import './Navbar.css';

const Navbar = ({ setLabel }) => {
  useEffect(() => {
    // Inicializa el menú hamburguesa de MaterializeCSS
    const elems = document.querySelectorAll('.sidenav');
    M.Sidenav.init(elems);
  }, []);

  return (
    <>
      <nav className="nav-wrapper purple-casa-arcana">
        <div className="container">
          {/* Ícono de menú hamburguesa (visible en pantallas pequeñas) */}
          <a href="/" data-target="mobile-menu" className="sidenav-trigger">
            <i className="material-icons">menu</i>
          </a>

          {/* Logo */}
          <Link to="/" className="brand-logo">
            <img src="/images/casarcana.png" alt="Logo Casa Arcana" className="logo-navbar" />
          </Link>

          {/* Menú para pantallas grandes */}
          <ul className="right hide-on-med-and-down">
            <li><Link to="/" onClick={() => setLabel("home")}>Inicio</Link></li>
            <li><Link to="/horoscopo" onClick={() => setLabel("horoscopo")}>Horóscopo Diario</Link></li>
            <li><Link to="/frase" onClick={() => setLabel("frase")}>Frase del Día</Link></li>
            <li><Link to="/compatibilidad" onClick={() => setLabel("compatibilidad")}>Compatibilidad de Signos</Link></li>
            {/* <li><Link  to="/tirada">Tirada Tarot</Link></li> */}
          </ul>
        </div>
      </nav>

      {/* Menú lateral para pantallas pequeñas */}
      <ul className="sidenav" id="mobile-menu">
        <li><Link  to="/" onClick={() => setLabel("horoscopo")}>Horóscopo Diario</Link></li>
        <li><Link  to="/" onClick={() => setLabel("frase")}>Frase del Día</Link></li>
        <li><Link  to="/" onClick={() => setLabel("compatibilidad")}>Compatibilidad de Signos</Link></li>
        {/*<li><Link to="/tirada">Tirada Tarot</Link></li>*/}
      </ul>
    </>
  );
};

export default Navbar;
